import * as XLSX from 'xlsx';

export interface ParsedExcelData {
  filename: string;
  sheets: Record<string, any[]>;
}

export const parseExcel = (file: File): Promise<ParsedExcelData> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event: ProgressEvent<FileReader>) => {
      try {
        const target = event.target;
        if (!target || !target.result) {
          throw new Error('Failed to read file data');
        }

        const data = target.result;
        // Parse the workbook using modern array buffer type
        const workbook = XLSX.read(data, { type: 'array' });

        const parsedSheets: Record<string, any[]> = {};

        workbook.SheetNames.forEach(sheetName => {
          const workSheet = workbook.Sheets[sheetName];
          // sheet_to_json automatically uses the first row as headers and filters empty rows
          const sheetRows = XLSX.utils.sheet_to_json(workSheet, { blankrows: false });
          parsedSheets[sheetName] = sheetRows;
        });

        resolve({
          filename: file.name,
          sheets: parsedSheets,
        });
      } catch (error) {
        reject(error);
      }
    };
    reader.onerror = error => reject(error);
    reader.readAsArrayBuffer(file);
  });
};
